<template>
  <Modal v-model="modalSettingEffective" width="400">
    <p slot="header" class="text-center">
        <span>启用设置</span>
    </p>
    <Row >
      <i-col span="24">
        <RadioGroup v-model="saveBean.flag" vertical>
          <Radio :label="1">
              <span>立即启用</span>
          </Radio>
          <Radio :label="2">
              <span>设置启用时间</span>
          </Radio>
        </RadioGroup>
      </i-col>
    </Row>
    <Row >
      <i-col span="24">
        <DatePicker type="date" :disabled="saveBean.flag===1" v-model="effectiveDate" placeholder="设置启用日期" style="width: 150px"></DatePicker>
        <TimePicker v-model="effectiveTime" :disabled="saveBean.flag===1" class="m-l-10" placeholder="设置启用时间" style="width: 168px"></TimePicker>
        <p v-if="showErrorMsg" class="text-red m-t-5">* 请正确填写启用时间！</p>
      </i-col>
    </Row>

    <div slot="footer">
      <Button type="text" @click="modalSettingEffective = false">取消</Button>
      <Button type="primary" @click="handleSubmit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { ParseDate } from '@/utils/dateFormat'
import { setVersionStartTime } from '@/api/msp/serviceversion'

export default {
  data () {
    return {
      modalSettingEffective: false,
      saveBean: {
        flag: 1,
        versionId: 0,
        startTime: ''
      },

      effectiveDate: null,
      effectiveTime: null,

      showErrorMsg: false
    }
  },
  methods: {
    showModal (serviceVersionId) {
      this.modalSettingEffective = true
      this.saveBean.flag = 1
      this.showErrorMsg = false
      this.saveBean.versionId = serviceVersionId
    },
    handleSubmit () {
      if (this.saveBean.flag === 2 && (!this.effectiveDate || !this.effectiveTime)) {
        this.showErrorMsg = true
        return
      }

      this.saveBean.startTime = ParseDate(this.effectiveDate) + ' ' + this.effectiveTime
      setVersionStartTime(this.saveBean).then(res => {
        if (res.success) {
          this.$emit('setting-effective-success')
          this.$Notice.success({ desc: '启用设置成功！' })
          this.modalSettingEffective = false
        }
      })
    }
  }
}
</script>
